<template>
  <div class="calculator" :class="calculatorName" :id="calculatorName">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12 col-xxl-8">
          <div class="progress-container">
            <div class="progress-bar-bg">
              <div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
            </div>
          </div>

          <div class="step-nav-buttons mt-4">
                <button
                  type="button"
                  class="btn previous-step"
                  @click="prevStep"
                  v-if="currentStep != 1"
                >
                  Back
                </button>
          </div>

          <div class="calculator-container">

            <div @keyup="resetCalculation" @change="resetCalculation">
              <BooleanChoiceButtons
                  fieldText="Which of these best describes your current situation?"
                  buttonTextLeft="I'm buying a home"
                  buttonTextRight="I'm remortgaging"
                  v-if="currentStep === 1"
              >
                <template v-slot:left>
                  <input type="radio" v-model="startOption" value="Buying">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="startOption" value="Remortgaging">
                </template>
              </BooleanChoiceButtons>

              <div key="buying" >
                <BooleanChoiceButtons
                    fieldText="Do you have a property in mind?"
                    buttonTextLeft="Yes"
                    buttonTextRight="No"
                    v-if="currentStep === 2"
                >
                  <template v-slot:left>
                    <input type="radio" v-model="propertyOption" value="Yes">
                  </template>
                  <template v-slot:right>
                    <input type="radio" v-model="propertyOption" value="No">
                  </template>
                </BooleanChoiceButtons>

                
                  <InputElement
                    v-if="currentStep === 3"
                    fieldText="What is the purchase price?"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="purchasePrice"/>
                  </InputElement>
                

                
                  <InputElement
                      v-if="currentStep === 4"
                      fieldText="What mortgage amount are you looking for?"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="mortgageAmount"/>
                  </InputElement>
                
                <!--EOF buying -->      
              </div>

              <div key="remortgaging" >
                <div v-if="currentStep === 5">
                  <InputElement
                      fieldText="What is the approximate value of your property?"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="propertyValue"/>
                  </InputElement>

                </div>

                <div v-if="currentStep === 6">
                  <InputElement
                      fieldText="What is your approximate current mortgage outstanding?"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="outstandingMortgage"/>
                  </InputElement>

                </div>
              </div>

              <BooleanChoiceButtons
                  v-if="currentStep === 7"
                  fieldText="Number of applicants"
                  buttonTextLeft="1"
                  buttonTextRight="2"
              >
                <template v-slot:left>
                  <input type="radio" v-model="applicantsCount" :value="1">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="applicantsCount" :value="2">
                </template>
              </BooleanChoiceButtons>

              <div v-if="currentStep === 8">
                <InputElement
                    fieldText="First Applicant Details"
                    subText="First applicant annual income (including benefits)?"
                >
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome1"/></InputElement>
              </div>

              <div v-if="currentStep === 9">
                <h4 class="calc-fieldset-title" v-if="applicantsCount === 2">First Applicant Details</h4>
                <BooleanChoiceButtons
                    fieldText="Do you have your credit report?"
                    buttonTextLeft="Yes"
                    buttonTextRight="No"
                >
                  <template v-slot:left>
                    <input type="radio" v-model="creditReport1" value="Yes">
                  </template>
                  <template v-slot:right>
                    <input type="radio" v-model="creditReport1" value="No">
                  </template>
                </BooleanChoiceButtons>
              </div>

              <div class="row mb-5" v-if="currentStep === 10">
                <h4 class="calc-fieldset-title" v-if="applicantsCount === 2">First Applicant Details</h4>
                <div class="col-12 booleanLabel">Where did you source your credit report from?</div>
                <div class="col-12 row mx-0 calc-right-buttons-wrapper">
                  <MultiplyChoiceButton
                      buttonText="Experian"
                  >
                    <input type="radio" v-model="creditAgency1" value="Experian">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="CreditKarma"
                  >
                    <input type="radio" v-model="creditAgency1" value="CreditKarma">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="Equifax"
                  >
                    <input type="radio" v-model="creditAgency1" value="Equifax">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="TransUnion"
                  >
                    <input type="radio" v-model="creditAgency1" value="TransUnion">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="Clearscore"
                  >
                    <input type="radio" v-model="creditAgency1" value="Clearscore">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="Check my file"
                  >
                    <input type="radio" v-model="creditAgency1" value="checkMyFile">
                  </MultiplyChoiceButton>
                </div>
              </div>

              <div v-if="currentStep === 11">
                <h4 class="calc-fieldset-title" v-if="applicantsCount === 2">First Applicant Details</h4>
                <InputElement
                    
                    fieldText="What is your credit score?"
                >
                  <InputTypeNumber v-model="creditScore1"/>
                </InputElement>
              </div>

              <div class="row mb-5" v-if="currentStep === 12">
                <h4 class="calc-fieldset-title" v-if="applicantsCount === 2">First Applicant Details</h4>
                <div class="col-12 booleanLabel">
                  Do you have any credit penalties? 
                </div>
                <div class="col-12 subLabel">
                  Let us know if you have ever received any of the following credit penalties and if so, how long ago was the penalty? (in years)
                </div>
                <div class="col-12 row mx-0 calc-right-buttons-wrapper">
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="noPenalty1" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label large">
                        I don’t have any credit penalties
                      </div>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousDefaulted1" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had a default
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousDefaultedValue1"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousIVA1" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had an IVA
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousIVAValue1"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousCCJ1" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had a CCJ
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousCCJValue1"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousDMP1" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had a DMP
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousDMPValue1"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousBankruptcy1" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve filed for bankruptcy
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousBankruptcy1"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="latePayments1" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had missed or late payments
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="latePaymentsValue1"/>
                    </div>
                    
                  </div>
                </div>
              </div>

              <div v-if="currentStep === 13">
                <InputElement
                    fieldText="Second Applicant Details"
                    subText="Second applicant annual income (including benefits)?"
                >
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome2"/></InputElement>
              </div>

              <div v-if="currentStep === 14">
                <h4 class="calc-fieldset-title">Second Applicant Details</h4>
                <BooleanChoiceButtons
                    fieldText="Do you have your credit report?"
                    buttonTextLeft="Yes"
                    buttonTextRight="No"
                >
                  <template v-slot:left>
                    <input type="radio" v-model="creditReport2" value="Yes">
                  </template>
                  <template v-slot:right>
                    <input type="radio" v-model="creditReport2" value="No">
                  </template>
                </BooleanChoiceButtons>
              </div>

              <div class="row mb-5" v-if="currentStep === 15">
                <h4 class="calc-fieldset-title">Second Applicant Details</h4>
                <div class="col-12 booleanLabel">Where did you source your credit report from?</div>
                <div class="col-12 row mx-0 calc-right-buttons-wrapper">
                  <MultiplyChoiceButton
                      buttonText="Experian"
                  >
                    <input type="radio" v-model="creditAgency2" value="Experian">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="CreditKarma"
                  >
                    <input type="radio" v-model="creditAgency2" value="CreditKarma">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="Equifax"
                  >
                    <input type="radio" v-model="creditAgency2" value="Equifax">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="TransUnion"
                  >
                    <input type="radio" v-model="creditAgency2" value="TransUnion">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="Clearscore"
                  >
                    <input type="radio" v-model="creditAgency2" value="Clearscore">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="Check my file"
                  >
                    <input type="radio" v-model="creditAgency2" value="checkMyFile">
                  </MultiplyChoiceButton>
                </div>
              </div>

              <div v-if="currentStep === 16">
                <h4 class="calc-fieldset-title">Second Applicant Details</h4>
                <InputElement
                    
                    fieldText="What is your credit score?"
                >
                  <InputTypeNumber v-model="creditScore2"/>
                </InputElement>
              </div>

              <div class="row mb-5" v-if="currentStep === 17">
                <h4 class="calc-fieldset-title">Second Applicant Details</h4>
                <div class="col-12 booleanLabel">
                  Do you have any credit penalties? 
                </div>
                <div class="col-12 subLabel">
                  Let us know if you have ever received any of the following credit penalties and if so, how long ago was the penalty? (in years)
                </div>
                <div class="col-12 row mx-0 calc-right-buttons-wrapper">
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="noPenalty2" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label large">
                        I don’t have any credit penalties
                      </div>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousDefaulted2" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had a default
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousDefaultedValue2"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousIVA2" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had an IVA
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousIVAValue2"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousCCJ2" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had a CCJ
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousCCJValue2"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousDMP2" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had a DMP
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousDMPValue2"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="previousBankruptcy2" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve filed for bankruptcy
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="previousBankruptcy2"/>
                    </div>
                    
                  </div>
                  <div class="calc-question-wrapper tickbox">
                    <div class="calc-merged-btn">
                      <label class="calc-radio left">
                        <input type="checkbox" v-model="latePayments2" true-value="Yes" false-value="No">
                        <span class="checkbox large"></span>
                      </label>
                      <div class="tickbox-label">
                        I’ve had missed or late payments
                      </div>
                      <DropdownMenu :dropdownOptions="dropdownOptions" v-model="latePaymentsValue2"/>
                    </div>
                    
                  </div>
                </div>
              </div>

              <div class="row mb-5" v-if="currentStep === 18">
                <div class="col-12 booleanLabel">Why are you using the calculator today?</div>
                <div class="col-12 row mx-0 calc-right-buttons-wrapper">
                  <MultiplyChoiceButton
                      buttonText="I’m ready to get a mortgage"
                  >
                    <input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="I’m curious to know what I can borrow"
                  >
                    <input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="I want to understand what I can afford before I search for a home"
                  >
                    <input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
                  </MultiplyChoiceButton>
                  </div>
              </div>

              <div class="row mb-5" v-if="currentStep === 19">
                <div class="col-12 booleanLabel">When are you hoping to move?</div>
                <div class="col-12 row mx-0 calc-right-buttons-wrapper">
                  <MultiplyChoiceButton
                      buttonText="As soon as possible"
                  >
                    <input type="radio" v-model="calcReason2" value="As soon as possible">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="In the next 3 months"
                  >
                    <input type="radio" v-model="calcReason2" value="In the next 3 months">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="6-12 months from now"
                  >
                    <input type="radio" v-model="calcReason2" value="6-12 months from now">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="12+ months from now"
                  >
                    <input type="radio" v-model="calcReason2" value="12+ months from now">
                  </MultiplyChoiceButton>
                  </div>
              </div>
            </div>

            <div class="step-nav-buttons text-center">
              <button
                type="button"
                class="btn next-step"
                @click="nextStep"
                v-if="currentStep != totalSteps - 1 && currentStep != 20"
                :disabled="!isStepValid"
              >
                Continue
              </button>

              <button
                type="button"
                class="btn calculate"
                v-if="currentStep === totalSteps - 1"
                @click="calculate"
                :disabled="!isStepValid"
              >
                Calculate
              </button>
            </div>
          </div>

          <div v-if="currentStep === 20" ref="resultsContainer">

              <div class="row mb-3">
                <div class="col-12">
                  <ResultsContainer class="mb-3 full-height">
                    <h4 class="calculation">We predict you <b>could</b> borrow up to</h4>
                  </ResultsContainer>
                </div>
                <div class="col-12">
                  <ResultsContainer class="full-height">
                    <h4><span class="fcs-price">£{{ formattedMortgage }}<span class="asterisk">*</span></span></h4>
                  </ResultsContainer>
                </div>
              </div>

              <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody" />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
    DropdownMenu,
    InputElement,
    InputTypeNumber,
    MultiplyChoiceButton,
    ResultsContainer,
    SubmissionForm
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 20,
      calculatorName: 'bad-credit-calculator',
      startOption: "",

      propertyOption: "",
      purchasePrice: null,
      mortgageAmount: null,

      propertyValue: null,
      outstandingMortgage: null,

      applicantsCount: null,

      annualIncome1: null,
      creditReport1: "",
      creditAgency1: "",
      creditScore1: null,
      noPenalty1: "",
      noPenalty2: "",
      previousDefaulted1: null,
      previousDefaultedValue1: 0,
      previousIVA1: null,
      previousIVAValue1: 0,
      previousCCJ1: null,
      previousCCJValue1: 0,
      previousDMP1: null,
      previousDMPValue1: 0,
      previousBankruptcy1: null,
      previousBankruptcyValue1: 0,
      latePayments1: null,
      latePaymentsValue1: 0,

      annualIncome2: 0,
      creditReport2: "",
      creditAgency2: "",
      creditScore2: null,
      previousDefaulted2: null,
      previousDefaultedValue2: 0,
      previousIVA2: null,
      previousIVAValue2: 0,
      previousCCJ2: null,
      previousCCJValue2: 0,
      previousDMP2: null,
      previousDMPValue2: 0,
      previousBankruptcy2: null,
      previousBankruptcyValue2: 0,
      latePayments2: null,
      latePaymentsValue2: 0,

      multiplier: 4.95,

      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      dropdownOptions: [
        { value: 0, text: "How Long Ago?" },
        { value: 60, text: "Less than a year" },
        { value: 50, text: "1 year" },
        { value: 40, text: "2 years" },
        { value: 30, text: "3 years" },
        { value: 20, text: "4 years" },
        { value: 10, text: "5 years" },
        { value: 0, text: "6+ years" }
      ],
      dropdownOptionsReason: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "I'm ready to move forward with a mortgage", text: "I'm ready to move forward with a mortgage"},
        {
          value: "I'm not ready for a mortgage but am curious about what I could borrow",
          text: "I'm not ready for a mortgage but am curious about what I could borrow"
        },
        {
          value: "I'm starting to save for a house and want to know what to aim for",
          text: "I'm starting to save for a house and want to know what to aim for"
        },
        {
          value: "I need to understand a what I can afford before house shopping",
          text: "I need to understand a what I can afford before house shopping"
        },



      ],

      dropdownOptionsMove: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "12+ months", text: "12+ months"},
        {value: "6-12 months", text: "6-12 months"},
        {value: "In the next 3 months", text: "In the next 3 months"},
        {value: "As soon as possible", text: "As soon as possible"},
      ],
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 3, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 4 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
			this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    valueToZero(value) {
      if ( !Number.isInteger(value) ) { return 0 } return value
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    },
    nextStep() {
      if (this.currentStep === 1 && this.startOption === 'Remortgaging') {
        this.currentStep = 5;
      } else if (this.currentStep === 2 && this.propertyOption === 'No') {
        this.currentStep = 7;
      } else if (this.currentStep === 4 && this.startOption === 'Buying') {
        this.currentStep = 7;
      } else if (this.currentStep === 9 && this.creditReport1 === 'No' && this.applicantsCount === 1) {
        this.currentStep = 18;
      } else if (this.currentStep === 9 && this.creditReport1 === 'No' && this.applicantsCount === 2) {
        this.currentStep = 13;
      } else if (this.currentStep === 14 && this.creditReport2 === 'No') {
        this.currentStep = 18;
      } else if (this.currentStep === 12 && this.applicantsCount === 1) {
        this.currentStep = 18;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep === 5 && this.startOption === 'Remortgaging') {
        this.currentStep = 1;
      } else if (this.currentStep === 7 && this.propertyOption === 'No') {
        this.currentStep = 2;
      } else if (this.currentStep === 7 && this.startOption === 'Buying') {
        this.currentStep = 4;
      } else if (this.currentStep === 18 && this.creditReport1 === 'No' && this.applicantsCount === 1) {
        this.currentStep = 9;
      } else if (this.currentStep === 13 && this.creditReport1 === 'No' && this.applicantsCount === 2) {
        this.currentStep = 9;
      } else if (this.currentStep === 18 && this.creditReport2 === 'No') {
        this.currentStep = 14;
      } else if (this.currentStep === 18 && this.applicantsCount === 1) {
        this.currentStep = 12;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep--;
      }
    },
  },
  computed: {
    /**
     * Show 'Calculate' button
     * @return {Boolean}
     */
    isStepValid() {
      if (this.currentStep === 1) {
        return this.startOption === 'Buying' || this.startOption === 'Remortgaging';
      }
      if (this.currentStep === 2) {
        return this.propertyOption === 'Yes' || this.propertyOption === 'No';
      }
      if (this.currentStep === 3) {
        return this.purchasePrice != null;
      }
      if (this.currentStep === 4) {
        return this.mortgageAmount != null;
      }
      if (this.currentStep === 5) {
        return this.propertyValue != null;
      }
      if (this.currentStep === 6) {
        return this.outstandingMortgage != null;
      }
      if (this.currentStep === 7) {
        return this.applicantsCount === 1 || this.applicantsCount === 2;
      }
      if (this.currentStep === 8) {
        return this.annualIncome1 != null;
      }
      if (this.currentStep === 9) {
        return this.creditReport1 === 'Yes' || this.creditReport1 === 'No';
      }
      if (this.currentStep === 10) {
        return this.creditAgency1 === 'Experian' || this.creditAgency1 === 'CreditKarma' || this.creditAgency1 === 'Equifax' || this.creditAgency1 === 'TransUnion' || this.creditAgency1 === 'Clearscore' || this.creditAgency1 === 'checkMyFile';
      }
      if (this.currentStep === 11) {
        return this.creditScore1 != null;
      }
      if (this.currentStep === 12) {
        const hasDefault = this.previousDefaulted1 === 'Yes';
        const hasIVA = this.previousIVA1 === 'Yes';
        const hasCCJ = this.previousCCJ1 === 'Yes';
        const hasDMP = this.previousDMP1 === 'Yes';
        const hasBankruptcy = this.previousBankruptcy1 === 'Yes';
        const hasLate = this.latePayments1 === 'Yes';
        const hasNoPenalty = this.noPenalty1 === 'Yes';

        if (hasDefault) {
          return this.previousDefaultedValue1 > 0;
        } else if (hasIVA) {
          return this.previousIVAValue1 > 0;
        } else if (hasCCJ) {
          return this.previousCCJValue1 > 0;
        } else if (hasDMP) {
          return this.previousDMPValue1 > 0;
        } else if (hasBankruptcy) {
          return this.previousBankruptcyValue1 > 0;
        } else if (hasLate) {
          return this.latePaymentsValue1 > 0;
        }

        return hasNoPenalty;
      }
      if (this.currentStep === 13) {
        return this.annualIncome2 != null;
      }
      if (this.currentStep === 14) {
        return this.creditReport2 === 'Yes' || this.creditReport2 === 'No';
      }
      if (this.currentStep === 15) {
        return this.creditAgency2 === 'Experian' || this.creditAgency2 === 'CreditKarma' || this.creditAgency2 === 'Equifax' || this.creditAgency2 === 'TransUnion' || this.creditAgency2 === 'Clearscore' || this.creditAgency2 === 'checkMyFile';
      }
      if (this.currentStep === 16) {
        return this.creditScore2 != null;
      }
      if (this.currentStep === 17) {
        const hasDefault2 = this.previousDefaulted2 === 'Yes';
        const hasIVA2 = this.previousIVA2 === 'Yes';
        const hasCCJ2 = this.previousCCJ2 === 'Yes';
        const hasDMP2 = this.previousDMP2 === 'Yes';
        const hasBankruptcy2 = this.previousBankruptcy2 === 'Yes';
        const hasLate2 = this.latePayments2 === 'Yes';
        const hasNoPenalty2 = this.noPenalty2 === 'Yes';

        if (hasDefault2) {
          return this.previousDefaultedValue2 > 0;
        } else if (hasIVA2) {
          return this.previousIVAValue2 > 0;
        } else if (hasCCJ2) {
          return this.previousCCJValue2 > 0;
        } else if (hasDMP2) {
          return this.previousDMPValue2 > 0;
        } else if (hasBankruptcy2) {
          return this.previousBankruptcyValue2 > 0;
        } else if (hasLate2) {
          return this.latePaymentsValue2 > 0;
        }

        return hasNoPenalty2;
      }
      if (this.currentStep === 18) {
        return this.calcReason1 != null;
      }
      if (this.currentStep === 19) {
        return this.calcReason2 != null;
      }
      return true;
    },
    showListFields() {
      let listFields
      if ( this.applicantsCount < 1 ) { return listFields = false }
      this.applicantsCount == 1
          ? ( this.creditReport1 === 'No' || ( this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "" ) ) ? listFields = true : listFields = false
          : ( this.creditReport2 === 'No' || ( this.previousDefaulted2 !== "" && this.previousIVA2 !== "" && this.previousCCJ2 !== "" && this.previousDMP2 !== "" && this.previousBankruptcy2 !== "" && this.LatePayments2 !== "" ) ) && ( this.creditReport1 === 'No' || ( this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "" ) ) ? listFields = true : listFields = false
      return listFields
    },
    showCalculateButton() {
      let calculateButton
      if ( this.applicantsCount < 1 ) { return calculateButton = false }
      this.applicantsCount == 1
          ? ( this.creditReport1 === 'No' || ( this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "" ) ) ? calculateButton = true : calculateButton = false
          : ( this.creditReport2 === 'No' || ( this.previousDefaulted2 !== "" && this.previousIVA2 !== "" && this.previousCCJ2 !== "" && this.previousDMP2 !== "" && this.previousBankruptcy2 !== "" && this.LatePayments2 !== "" ) ) && ( this.creditReport1 === 'No' || ( this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "" ) ) ? calculateButton = true : calculateButton = false
      return calculateButton
    },
    /**
     * Calculate total income (of both applicants if available)
     * @return {Number}
     */
    totalIncome() {
      return this.valueToZero(this.annualIncome1) + this.valueToZero(this.annualIncome2)
    },
    /**
     * Calculate maximum mortgage available
     * @return {Number}
     */
    availableMortgage() {
      return this.totalIncome * this.multiplier
    },
    formattedMortgage() {
      return new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.availableMortgage);
    },
    /**
     * Calculate total penalties of the applicant
     * @return {Number}
     */
    creditPenaltiesApplicant1() {
      return parseInt(this.previousDefaultedValue1) + parseInt(this.previousIVAValue1) + parseInt(this.previousCCJValue1) + parseInt(this.previousDMPValue1) + parseInt(this.previousBankruptcyValue1) + parseInt(this.latePaymentsValue1)
    },
    creditPenaltiesApplicant2() {
      return parseInt(this.previousDefaultedValue2) + parseInt(this.previousIVAValue2) + parseInt(this.previousCCJValue2) + parseInt(this.previousDMPValue2) + parseInt(this.previousBankruptcyValue2) + parseInt(this.latePaymentsValue2)
    },
    /**
     * Calculate total score of the applicant
     * @return {Number}
     */
    totalApplicantScore1() {
      let calculatedCreditScore = this.creditScore1 ? this.creditScore1 : 0
      return calculatedCreditScore - this.creditPenaltiesApplicant1
    },
    totalApplicantScore2() {
      let calculatedCreditScore = this.creditScore2 ? this.creditScore2 : 0
      return calculatedCreditScore - this.creditPenaltiesApplicant2
    },
    /**
     * Find the lowest score if more then one applicant
     * @return {Number}
     */
    creditScoreValue() {
      let calculatedCreditScoreValue
      if ( this.applicantsCount < 1 ) { return calculatedCreditScoreValue = 0 }
      this.applicantsCount == 1
          ? calculatedCreditScoreValue = this.totalApplicantScore1
          : calculatedCreditScoreValue = ( this.totalApplicantScore1 >= this.totalApplicantScore2 ) ? this.totalApplicantScore2 : this.totalApplicantScore1
      return calculatedCreditScoreValue
    },
    /**
     * Calculate the total income for the household
     * @return {Number}
     */
    householdIncome() {
      let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
      let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

      return annualIncome1 + annualIncome2;
    },
    collateMessageBody() {
      let calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Applicants: ${this.applicantsCount}
					Buying or Remortgaging: ${this.startOption}

					Do you have a property in mind? ${this.propertyOption}
					Purchase price: £${this.formatEmptyMessageFields(this.purchasePrice)}
					Mortgage amount: £${this.formatEmptyMessageFields(this.mortgageAmount)}

					Approximate property value: £${this.formatEmptyMessageFields(this.propertyValue)}
					Approximate outstanding mortgage: £${this.formatEmptyMessageFields(this.outstandingMortgage)}

					Applicant 1 Income: £${this.annualIncome1}
					Applicant 1 Credit Report: ${this.formatEmptyMessageFields(this.creditReport1)}
					Applicant 1 Credit Service: ${this.formatEmptyMessageFields(this.creditAgency1)}
					Applicant 1 Credit Score: ${this.formatEmptyMessageFields(this.creditScore1)}
					Applicant 1 Penalties:
							Have you ever had a default? ${this.formatEmptyMessageFields(this.previousDefaulted1)}
							Result: ${this.previousDefaultedValue1}

							Have you had an IVA? ${this.formatEmptyMessageFields(this.previousIVAValue1)}
							Result: ${this.previousIVAValue1}

							Have you had a CCJ? ${this.formatEmptyMessageFields(this.previousCCJ1)}
							Result: ${this.previousCCJValue1}

							Have you ever had a DMP? ${this.formatEmptyMessageFields(this.previousDMP1)}
							Result: ${this.previousCCJValue1}

							Have you ever filed for Bankruptcy? ${this.formatEmptyMessageFields(this.previousBankruptcy1)}
							Result: ${this.previousBankruptcyValue1}

							Have you had missed or late payments? ${this.formatEmptyMessageFields(this.latePayments1)}
							Result: ${this.latePaymentsValue1}

					Applicant 2 Income: ${this.annualIncome2}
					Applicant 2 Credit Report; ${this.formatEmptyMessageFields(this.creditReport2)}
					Applicant 2 Credit Service: ${this.formatEmptyMessageFields(this.creditAgency2)}
					Applicant 2 Credit Score: ${this.formatEmptyMessageFields(this.creditScore2)}
					Applicant 2 Penalties:
							Have you ever had a default? ${this.formatEmptyMessageFields(this.previousDefaulted2)}
							Result: ${this.previousDefaultedValue2}

							Have you had an IVA? ${this.formatEmptyMessageFields(this.previousIVAValue2)}
							Result: ${this.previousIVAValue2}

							Have you had a CCJ? ${this.formatEmptyMessageFields(this.previousCCJ2)}
							Result: ${this.previousCCJValue2}

							Have you ever had a DMP? ${this.formatEmptyMessageFields(this.previousDMP2)}
							Result: ${this.previousCCJValue2}

							Have you ever filed for Bankruptcy? ${this.formatEmptyMessageFields(this.previousBankruptcy2)}
							Result: ${this.previousBankruptcyValue2}

							Have you had missed or late payments? ${this.formatEmptyMessageFields(this.latePayments2)}
							Result: ${this.latePaymentsValue2}

					Household Income: £${this.householdIncome}
					Available Mortgage: £${this.availableMortgage}

					Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
				`
      }
      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>
